import React, { Fragment } from "react";
import styles from "./kilometer.module.css";

const KilometerCar = ({ kilometer }) => {
  const digits = kilometer.toString().split("");
  return (
    <span className={styles["odometer"]}>
      <span className={styles["mileage"]}>
        {digits.map((d, i) => (
          <span key={i}>{d}</span>
        ))}
      </span>
      <span className={styles["units"]}>KM</span>
    </span>
  );
};


export default KilometerCar;

